import { render, staticRenderFns } from "./Splash.vue?vue&type=template&id=cce49e8a&scoped=true&"
import script from "./Splash.vue?vue&type=script&lang=js&"
export * from "./Splash.vue?vue&type=script&lang=js&"
import style0 from "theme/css/main.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./Splash.vue?vue&type=style&index=1&id=cce49e8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce49e8a",
  null
  
)

export default component.exports